module.exports = __webpack_public_path__ + "img/wq.7e789f0a.png";